import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import Button from "../../../Button/button";
import Input from "../../../input/signInput/input"
import style from "./StepOne.module.scss";
import Toast from '../../../Toast/Toast'
import toEnglishNumber from "../../../../helpers/actions/toEnglishNumber";
import { RegisterForm } from "../../../../actions/APIcalls"

const StepOne = (props) => {
    const [registerInfo, setRegisterInfo] = useState({
        tel: '',
        password: '',
        telError: '',
        passwordError: '',
        acceptTerms: false,
    })
    const [showToast, setShowToast] = useState(false)
    const [loading, setLoading] = useState(false);

    const handleBlure = (tag, e) => {
        if (tag === "tel") {
            telValidation();
        } else {
            passwordValidation()
        }
    }

    const telValidation = () => {
        let reg = new RegExp("^(09)[0-9]{9}$");
        if (reg.test(toEnglishNumber(registerInfo.tel)) && registerInfo.tel.length !== 0) {
            setRegisterInfo({ ...registerInfo, telError: '' })
            return true
        } else {
            if (registerInfo.tel.length === 0) {
                setRegisterInfo({ ...registerInfo, telError: 'شماره موبایل خود را وارد کنید' })
            } else {
                setRegisterInfo({ ...registerInfo, telError: 'شماره موبایل وارد شده صحیح نیست!' })
            }
            return false;
        }
    }
    const passwordValidation = () => {
        if (!registerInfo.password) {
            setRegisterInfo({ ...registerInfo, passwordError: 'رمز عبور خود را وارد کنید' })
        } else {
            setRegisterInfo({ ...registerInfo, passwordError: '' })
        }
    }

    const closeToast = () => {
        setShowToast(!showToast);
    }

    const handleForm = (tag, e) => {
        if (tag === 'tel') {
            let temp1 = registerInfo;
            let reg = new RegExp(/^\d+$/);
            if (reg.test(toEnglishNumber(e.target.value)) && e.target.value.length < 12) {
                temp1.tel = toEnglishNumber(e.target.value);
            } else if (e.target.value === "") {
                console.log("empty");
                temp1.tel = ""
            }
            setRegisterInfo({ ...temp1 })
        }
        if (tag === 'password') {
            setRegisterInfo({ ...registerInfo, password: e.target.value })
        }
    }

    const registerForm = async () => {
        if (!registerInfo.telError && !registerInfo.passwordError && registerInfo.password && registerInfo.tel && registerInfo.acceptTerms) {
            setLoading(true);
            let params = {
                password: toEnglishNumber(registerInfo.password),
                phone: toEnglishNumber(registerInfo.tel),
            }
            let res = await RegisterForm(params)
            if (typeof res !== "undefined" && typeof res.data !== "undefined") {
                props.history.push({
                    pathname: '/signup/steptwo',
                    state: { tel: registerInfo.tel, password: toEnglishNumber(registerInfo.password) }
                })
                setLoading(false);
            } else {
                setShowToast({ show: true, text: res.response.data.error })
                setLoading(false);
            }
        } else {
            if (!registerInfo.password) {
                setRegisterInfo({ ...registerInfo, passwordError: 'رمز عبور خود را وارد کنید' })
            }
            if (!registerInfo.tel) {
                setRegisterInfo({ ...registerInfo, telError: 'شماره موبایل خود را وارد کنید' })
            }
        }
    }
    return (
        <React.Fragment>
            <div className={style.signUpStepOne}>
                <Toast
                    tag='repeatedNumber'
                    value={showToast}
                    text='کاربر تکراری است!'
                    parentClose={closeToast} />

                <div className={style.stepOneFrame}>
                    <h3>ثبت‌نام</h3>
                    <div className={style.stepOneFormFrame}>

                        <Input
                            type="text"
                            disabled={false}
                            label="شماره موبایل"
                            placeholder=" - - - - - - - - - ۰۹"
                            tag="tel"
                            value={registerInfo.tel}
                            error={registerInfo.telError}
                            tooltip=''
                            onchange={handleForm}
                            onblur={handleBlure}
                        />
                        <div style={{ height: '24px' }}></div>
                        <div onKeyDown={(event) =>
                            event.key === "Enter" ? registerForm() : null
                        }
                        >
                            <Input
                                type="password"
                                disabled={false}
                                label="رمز عبور"
                                placeholder="رمز عبور"
                                tag="password"
                                value={registerInfo.password}
                                error={registerInfo.passwordError}
                                tooltip=''
                                onchange={handleForm}
                                onblur={handleBlure}
                            /></div>

                        <div className={style.acceptTermsWrapper}>
                            <input
                                className={registerInfo.acceptTerms ? style.inputChecked : style.inputCheckboxClass}
                                onChange={() => setRegisterInfo({ ...registerInfo, acceptTerms: !registerInfo.acceptTerms })}
                                type='checkbox'>
                            </input>
                            <p>
                                <a className={style.termsLink} href="https://mobisha.ir/terms" aria-label="terms" target="blank">شرایط و قوانین</a> استفاده از ربات موبیشا را می‌پذیرم
                            </p>
                        </div>
                    </div>

                    <div className={style.buttonFrame}>
                        <Button
                            loading={loading}
                            disabled={false}
                            tag="register"
                            type="solid"
                            label="ثبت‌نام"
                            onclick={registerForm}
                        />
                        <p className={style.registerLink}>قبلا ثبت‌‌نام کرده‌اید؟
                            <span className={style.link}>
                                <Link
                                    to='/signin/main'>ورود به موبیشا</Link>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(StepOne);